import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalInsurance, IInsuranceItem, InsuranceItem } from '../../../../../../models/insurance-item.model';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../../../../services/alert.service';
import { InsuranceItemService } from '../../../../../../services/insurance-item.service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { TransporterMapper } from '../../../../mapper/transporter-mapper';
import { OfferService } from '../../../../../../services/offer.service';
import { mapAsBody } from '../../../../util/request-util';
import { Transporter } from '../../../../../../models/transporter.model';
import { OfferViewDTO } from '../../../../../../models/offer-view-dto.type';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { CurrentDataService } from '../../../../../../services/current-data-service';

@Component({
  selector: 'jhi-insurance-items-list-light',
  templateUrl: './insurance-items-list-light.component.html',
})
export class InsuranceItemsListLightComponent implements OnInit {
  @Input() insuranceItems: IInsuranceItem[] | undefined;
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();
  PATHS = PATHS;
  transporter?: Transporter;
  IOfferViewDTOs: OfferViewDTO[] = [];
  offerAlliasTabTest: { insuranceItems: IInsuranceItem; offers: OfferViewDTO[] }[] = [];

  constructor(
    protected modalService: BaryModalService,
    protected translateService: TranslateService,
    protected alertService: AlertService,
    protected baryModalService: BaryModalService,
    protected insuranceItemService: InsuranceItemService,
    protected offerService: OfferService,
    protected currentDataService: CurrentDataService
  ) {}

  ngOnInit(): void {
    // ré
    this.currentDataService.getCurrentTransporter().subscribe(it => (this.transporter = it));

    this.offerService
      .getTransporterOffersWithName(this.transporter?.id!)
      .pipe(mapAsBody)
      .subscribe(it => {
        this.IOfferViewDTOs = it;

        this.IOfferViewDTOs.forEach(offer => {
          if (!offer.isQuotation) {
            this.insuranceItemService
              .findAllByOfferId(offer.id!)
              .pipe(mapAsBody)
              .subscribe(iit => {
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                iit.filter((ii: InsuranceItem) => {
                  // ii.id = undefined;
                  if (ii.quotationRequired == null) {
                    ii.quotationRequired = false;
                  }
                  if (!this.offerAlliasTabTest.find(iibf => iibf.insuranceItems.itemsNature === ii.itemsNature)) {
                    const tab: OfferViewDTO[] = [];
                    tab.push(offer);
                    this.offerAlliasTabTest.push({ insuranceItems: ii, offers: tab });
                  } else {
                    if (
                      this.offerAlliasTabTest.find(
                        iibf =>
                          // iibf.insuranceItems == ii
                          iibf.insuranceItems.itemsNature === ii.itemsNature &&
                          iibf.insuranceItems.insuranceRate === ii.insuranceRate &&
                          iibf.insuranceItems.pricingRate === ii.pricingRate &&
                          iibf.insuranceItems.basePricing === ii.basePricing &&
                          iibf.insuranceItems.maxValue === ii.maxValue &&
                          iibf.insuranceItems.quotationRequired === ii.quotationRequired
                        // && !iibf.alias.find(t2=>t2===offer.alias)
                      )
                    ) {
                      this.offerAlliasTabTest
                        .filter(
                          tt =>
                            tt.insuranceItems.itemsNature === ii.itemsNature &&
                            tt.insuranceItems.insuranceRate === ii.insuranceRate &&
                            tt.insuranceItems.pricingRate === ii.pricingRate &&
                            tt.insuranceItems.basePricing === ii.basePricing &&
                            tt.insuranceItems.maxValue === ii.maxValue &&
                            tt.insuranceItems.quotationRequired === ii.quotationRequired
                        )
                        .map(tt => tt.offers.push(offer));
                    } else {
                      if (
                        this.offerAlliasTabTest.find(
                          iibf =>
                            // iibf.insuranceItems != ii
                            iibf.insuranceItems.itemsNature === ii.itemsNature &&
                            (iibf.insuranceItems.insuranceRate !== ii.insuranceRate ||
                              iibf.insuranceItems.pricingRate !== ii.pricingRate ||
                              iibf.insuranceItems.basePricing !== ii.basePricing ||
                              iibf.insuranceItems.maxValue !== ii.maxValue ||
                              iibf.insuranceItems.quotationRequired !== ii.quotationRequired)
                          // && !iibf.alias.find(t2=>t2===offer.alias)
                        )
                      ) {
                        // this.offerAlliasTabTest.push(ii);
                        const tab: OfferViewDTO[] = [];
                        tab.push(offer);
                        this.offerAlliasTabTest.push({ insuranceItems: ii, offers: tab });
                      }
                    }
                  }
                });
              });
          }
        });
      });
    // this.insuranceItemService.find()
  }

  trackId(index: number, item: IInsuranceItem): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  edit(insuranceItem?: InsuranceItem): void {
    this.modalService
      .openAddOrUpdateInsuranceItem(insuranceItem, true)
      .action()
      .subscribe(action => {
        const globalInsurance: GlobalInsurance = TransporterMapper.getGlobalInsuranceFromInsuranceItem(action.value);
        let offers: OfferViewDTO[] = [];
        this.offerAlliasTabTest.filter(it => it.insuranceItems === insuranceItem).map(tt => (offers = tt.offers));
        globalInsurance.offers = offers;
        if (action.submit) {
          this.insuranceItemService.updateGlobalByName(globalInsurance).subscribe(() => {
            const successMessage = this.translateService.instant('baryApp.insuranceItem.global.updated', { param: action.value.itemsNature });
            this.alertService.addAlert({ message: successMessage, type: 'success' });
            this.transition();
          });
        }
      });
  }

  isHidden(): boolean {
    return (this.insuranceItems && this.insuranceItems.length > 0) ?? false;
  }

  sortByName(): { insuranceItems: IInsuranceItem; offers: OfferViewDTO[] }[] {
    return this.offerAlliasTabTest.sort((a, b) =>
      a.insuranceItems!.itemsNature! > b.insuranceItems!.itemsNature! ? 1 : a.insuranceItems.itemsNature === b.insuranceItems.itemsNature ? 0 : -1
    );
  }
}
